module.exports = __webpack_public_path__ + "static/media/Geomanist-Medium.e2952532.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Geomanist/Web/Geomanist-Medium.woff
// module id = 6546
// module chunks = 1